import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-settings-deployment',
  templateUrl: './power-settings-deployment.component.html',
  styleUrls: ['./power-settings-deployment.component.scss']
})
export class PowerSettingsDeploymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
